import React from 'react'
import { Box, Typography } from '@mui/material'
import { formatCurrency } from 'components/DataGrid/operators/formatNumbers'

export const ParentTotalsSummary = ({
  totals,
}: {
  totals: { allTotal: number; activeRunningTotal: number; productCount?: number }
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
      <Box>
        <Typography variant="caption" color="text.secondary">
          Active Totals (running today)
        </Typography>
        <Typography variant="h6">{formatCurrency(totals.activeRunningTotal)}</Typography>
      </Box>
      <Box>
        <Typography variant="caption" color="text.secondary">
          Total (all products)
        </Typography>
        <Typography variant="h6">{formatCurrency(totals.allTotal)}</Typography>
      </Box>
      {typeof totals.productCount === 'number' && (
        <Box>
          <Typography variant="caption" color="text.secondary">
            Products
          </Typography>
          <Typography variant="h6">{totals.productCount}</Typography>
        </Box>
      )}
    </Box>
  )
}
